export default "__VITE_ASSET__a7a386b2__"